const Modules = [
  {
    id: 1,
    module: "Inventory",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 2,
    module: "Product",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 3,
    module: "Vendor",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Staff",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 5,
    module: "Roles & Permissions",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 6,
    module: "Audit Logs",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 7,
    module: "Department",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 8,
    module: "Category",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 9,
    module: "Class",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 10,
    module: "Program Build",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 11,
    module: "Stone",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 12,
    module: "Brand",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 13,
    module: "Store",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 14,
    module: "VM Code",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 15,
    module: "Promotion Code",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
]

export default Modules
